import React from 'react'
import GenericIcon from 'components/GenericIcon'

import {
  presenceErrorClass,
} from 'servos/formValidations'

class Card extends React.Component {
  render() {
    const { errorMessage, title, iconName } = this.props

    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <GenericIcon name={ iconName } />
          </div>
          {title}
        </div>
        {this.props.children}
      </div>
    )
  }
}

export default Card;
